var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',_vm._g({staticClass:"group-summary-panel",class:{
       'graded': _vm.status === _vm.HandgradingStatus.graded,
       'ungraded': _vm.status === _vm.HandgradingStatus.ungraded,
       'in-progress': _vm.status === _vm.HandgradingStatus.in_progress,
       'no-handgradeable-submission': _vm.status === _vm.HandgradingStatus.no_submission,
     }},_vm.$listeners),[_c('div',{staticClass:"member-names"},_vm._l((_vm.group_summary.member_names),function(member){return _c('div',{key:member,staticClass:"member-name"},[_vm._v(" "+_vm._s(member)+" ")])}),0),_c('div',{staticClass:"status"},[_vm._v(" "+_vm._s(_vm.status)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }